//封装好的转换函数
function zhuanhuan(value) {
  let sss = value.map((item) => {
    let newarr = [];
    //为了防止label和parentid一样冲突，增加唯一标识符khy_
    newarr = item.map((item1, index) => {
      switch (index) {
        case 0:
          return {
            label: item1+'khy_'+[index],
            parentid: undefined
          }
        case 1:
          return {
            label: item1+'khy_'+index,
            parentid: item[index - 1]+'khy_'+[index - 1]
          }
        case 2:
          return {
            label: item1,
            parentid: item[index - 1]+'khy_'+[index - 1]
          }
        // case 0:
        //   return {
        //     label: item1,
        //     parentid: undefined
        //   }
        // case 1:
        //   return {
        //     label: item1,
        //     parentid: item[index - 1]
        //   }
        // case 2:
        //   return {
        //     label: item1,
        //     parentid: item[index - 1]
        //   }
      }
    })
    return newarr
  })
  // console.log("sss",JSON.stringify(sss));
  let full = []
  for (var i = 0; i < sss.length; i++) {
    full = full.concat(sss[i])
  }
  //到这里就已经封装好了 full 改编成一维数组对象的形式
  //去掉数组中重复的对象信息
  //去掉数组内重复的对象
  function removeDuplicates(arr) {
    const result = [];
    const duplicatesIndices = [];
    // Loop through each item in the original array
    arr.forEach((current, index) => {
      if (duplicatesIndices.includes(index)) return;
      result.push(current);
      // Loop through each other item on array after the current one
      for (let comparisonIndex = index + 1; comparisonIndex < arr.length; comparisonIndex++) {
        const comparison = arr[comparisonIndex];
        const currentKeys = Object.keys(current);
        const comparisonKeys = Object.keys(comparison);
        // Check number of keys in objects
        if (currentKeys.length !== comparisonKeys.length) continue;
        // Check key names
        const currentKeysString = currentKeys.sort().join("").toLowerCase();
        const comparisonKeysString = comparisonKeys.sort().join("").toLowerCase();
        if (currentKeysString !== comparisonKeysString) continue;
        // Check values
        let valuesEqual = true;
        for (let i = 0; i < currentKeys.length; i++) {
          const key = currentKeys[i];
          if (current[key] !== comparison[key]) {
            valuesEqual = false;
            break;
          }
        }
        if (valuesEqual) duplicatesIndices.push(comparisonIndex);
      } // end for loop
    }); // end arr.forEach()
    return result;
  }
  //函数执行数组去重复对象数据  console.log(full);
  full = removeDuplicates(full);
  //把一维数组转换为多维数组
  function fnSetTreeData(data) {
    // console.log("beforeData========"+JSON.stringify(data))
    data = [...data];
    data.forEach((father) => {
      var branchArr = data.filter((child) => {
        if (father.label == child.parentid) child._hasParent = true;
        return father.label == child.parentid;
      });
      //可以让没有子元素的不显示children
      if (branchArr.length > 0) father.children = branchArr;
    });
    // console.log("afterdata==="+JSON.stringify(data))
    //都遍历完才知道谁有父级
    let filterData = data.filter((item) => {
      return !item._hasParent;
    })
    // console.log("beforefilterdata==="+JSON.stringify(filterData))
    //循环数据替换数字标志位 begin
    filterData.forEach((item,index) =>{
      // console.log("item======",item.label)
      item.label = item.label.replace('khy_0','');
      if(item.children){
        for(var i= 0;i<item.children.length;i++){
          item.children[i].label = item.children[i].label.replace('khy_1','');
        }
      }
      return item;
    })
    //循环数据替换数字标志位 end
    // console.log("filterData======"+JSON.stringify(filterData))
    return filterData
  }
  return fnSetTreeData(full)
}

//查询函数
function sumar(itemsarr) {
  let arrresult = [0]
  for (let x = 0; x < itemsarr.length; x++) {
let  xrt=[];
function combine_increase( iArr , start, rt, count , NUM, arr_len){ // 从有arr_len个元素的数组中抽取NUM个元素的组合所有可能
  let i = 0;
  for(let i=start; i<arr_len+1-count; i++){
      rt[count - 1]=i;
      if( count -1 == 0){
          let tmp=[];
          for(let j=NUM-1;j>=0;j--){
              tmp.push(itemsarr[rt[j]]);
          }
          xrt.push(tmp);
      }else{
          combine_increase( iArr , i+1 , rt, count -1 , NUM, arr_len);
      }
  }
}
var rt=new Array(3);
combine_increase(itemsarr, 0, rt, x+1, x+1, itemsarr.length);
//console.log(x,xrt,itemsarr,itemsarr.length,'看一下');
let isarrresult = [];
xrt.forEach((item,index)=>{
isarrresult[index] = item.reduce((first,scend)=>{
      return first + scend
  })
})
arrresult[x] = isarrresult
  }
 let [...dav] =  new Set(arrresult.flat(2))
 return dav
}

export default {
  zhuanhuan,sumar
}
